import * as types from "./actionTypes"

export function getResequenceCars({ station, track }) {
    return {
        type: types.GET_RESEQUENCE_CARS,
        data: { station, track },
    }
}

export function getResequenceCarsSuccess(data) {
    return {
        type: types.GET_RESEQUENCE_CARS_SUCCESS,
        data: data,
    }
}

export function getResequenceCarsFailure() {
    return {
        type: types.GET_RESEQUENCE_CARS_FAILURE,
    }
}

export function clearResequenceCars() {
    return {
        type: types.CLEAR_RESEQUENCE_CARS,
    }
}

export function saveResequenceCars({ station, track, cars }) {
    return {
        type: types.SAVE_RESEQUENCE_CARS,
        data: { station, track, cars },
    }
}
export function resequenceSuccess() {
    return {
        type: types.RESEQUENCE_SUCCESS,
    }
}

export function resequenceFailure() {
    return {
        type: types.RESEQUENCE_FAILURE,
    }
}

export function resequenceReset() {
    return {
        type: types.RESEQUENCE_RESET,
    }
}
